export const IS_LIVE      = true; // TEMP: local testing against localhost:4000 backend — flip back to true before deploying

export const BASE_URL     = IS_LIVE ? 'https://ennixelectronics.com/'     : 'http://localhost:3000/';
export const API_BASE_URL = IS_LIVE ? 'https://api.ennixelectronics.com'  : 'http://localhost:4000';

export const EMAIL_SUPPORT = "support@ennixelectronics.com";
export const CLARITY_APP_ID   = "xgpzpu6930"

// Google Sign-In — OAuth client ID (public, safe to ship to the browser; no client secret needed here).
export const GOOGLE_CLIENT_ID = "644523382846-r53iairmsoh8lhrbkhcake879qp4a00q.apps.googleusercontent.com";

// Google Geocoding API key — SERVER-SIDE ONLY. Only ever import this from a Route Handler
// (src/app/api/**/route.js) or other server-only code, never from a 'use client' component,
// or it will end up in the browser bundle.
export const GOOGLE_MAPS_API_KEY = "AIzaSyACJHmOcZy4eNYBmv7s1MjDhq686tkUjhM";